"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const commands_1 = require("../lib/commands");
const $ = require("jquery");
function sendDetailsToSelf(ajaxPageUrl, articleId) {
    return __awaiter(this, void 0, void 0, function* () {
        const command = new commands_1.CommandCaller(ajaxPageUrl);
        const response = yield command.runPost('email details to current user', { articleId: articleId });
        alert(response.message);
    });
}
exports.sendDetailsToSelf = sendDetailsToSelf;
function initElementsWithDataAttributes(ajaxPageUrl, nodeToSearch) {
    const attribute = 'data-email-details-to-current-user';
    const selector = `[${attribute}]`;
    const foundNodes = nodeToSearch != null ? $(nodeToSearch).find(selector) : $(selector);
    foundNodes.each((i, element) => element.onclick = function (event) {
        event.preventDefault();
        const articleId = $(element).attr(attribute);
        sendDetailsToSelf(ajaxPageUrl, parseInt(articleId));
    });
}
exports.initElementsWithDataAttributes = initElementsWithDataAttributes;
//# sourceMappingURL=email details to myself.js.map


// WEBPACK FOOTER //
// ./build/news2/email details to myself.js